import { store$, store } from '@redux/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { createAuthInstance, showModal } from 'libraries/authLibrary';
import { isAuthLibraryLoaded, isAuthModalOpen } from '../constants/auth0Constants';
import { modalSlice, authenticationSlice } from '../redux/slices';
import getBaseConfig from './auth0BaseConfiguration';

const { actions: modalActions, reducer: modalReducers } = modalSlice;
const { reducer: authenticationReducers } = authenticationSlice

const configuration = getBaseConfig();
const onCloseModal = () => store.dispatch(modalActions.onClose());
const initAuthentication = () => createAuthInstance(configuration, onCloseModal);
const openModal = () => showModal();
const userIdSelector = (state) => state?.userProfile?.userId;
const invalidValuesFilter = (value) => !!value;

const storeUserId = (userId) => { 
    localStorage.setItem('UserId', userId)
 };

 // We have to execute initAuthentication when the modal is not opened.
 // So it means we need to track isAuthModalOpen.
 // Where if it was already on true, we should not continue the flow.
 // If it was on false, so we should check if the new isAuthModalOpen value is true or false to determine
 // whether to continue the flow.
store$.pipe(
    filter(isAuthLibraryLoaded),
    map(isAuthModalOpen),
    distinctUntilChanged(),
    filter(Boolean))
    .subscribe(initAuthentication);

store$.pipe(
    filter(isAuthModalOpen),
    distinctUntilChanged())
    .subscribe(openModal);

store$.pipe(
    map(userIdSelector),
    distinctUntilChanged(),
    filter(invalidValuesFilter)
  ).subscribe(storeUserId);

store.injectReducer('modal', modalReducers);
store.injectReducer('authentication', authenticationReducers);